import React, { useState, useEffect } from 'react';
import { notification } from 'antd';
import axios from 'axios';
import hljs from 'highlight.js/lib/core';

import { API_URL, ENDPOINTS } from '../constants/api';
import '../css/modal.css';

const InsertQuery = ({
  token,
  route,
  title,
  id,
  table,
  isOpen,
  onRequestClose,
}) => {
  console.log('modal:', id, table);
  const [data, setData] = useState(null);
  // Step 2: Function to copy the state's value to the clipboard
  const copyToClipboard = async (value) => {
    try {
      // Write the text to the clipboard using the Clipboard API
      await navigator.clipboard.writeText(value);
      notification.success({ message: 'Copied to clipboard!' });
    } catch (error) {
      console.error('Failed to copy: ', error);
    }
  };
  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/generate-insert-sql/${id}/${table}`;
    console.log('url:', url);
    axios
      .get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }) // Replace with your API
      .then((response) => {
        console.log('url:', url, 'response:', response.data);

        setData(response.data);
        copyToClipboard(response.data.query);
      })
      .catch((error) => console.error('Error fetching data:', error));
  }, [id]);

  return (
    <div
      className={`modal fade ${isOpen ? 'show' : ''}`}
      style={{ display: isOpen ? 'block' : 'none' }}
      tabIndex="-1"
      aria-hidden={isOpen ? 'false' : 'true'}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content  ">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onRequestClose}
            ></button>
          </div>
          <div className="modal-body  table-responsive">
            {data?.query ? (
              <div className="table-responsive">
                {/* <p>{data.query}</p> */}
                <pre
                  id="preview"
                  className="p-3 bg-light rounded border"
                  style={{ whiteSpace: 'pre-wrap', overflowX: 'auto' }}
                  dangerouslySetInnerHTML={{
                    __html: hljs.highlight(data.query, { language: 'sql' })
                      .value,
                  }}
                ></pre>
              </div>
            ) : (
              <p>Loading...</p>
            )}

            <button
              type="button"
              className="btn btn-secondary ms-2"
              onClick={onRequestClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsertQuery;
